import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useMetaBreadcrumbSchema } from './hooks/useMetaBreadcrumbSchema';

export const MetaBreadcrumbSchema: React.FC = () => {
	const {
		data: { displayed, schemaJson },
	} = useMetaBreadcrumbSchema();

	if (!displayed) return null;

	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
};
